import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Bot, ArrowRight } from "lucide-react";
import ModePicker from "@/components/autopilot/ModePicker";
import { errMsg } from "@/lib/api";
import api from "@/lib/api";
import { saveAutopilot } from "@/lib/autopilot";

export default function AutopilotSettingsSection() {
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/autopilot").then((r) => setCfg(r.data)).catch(() => {}); }, []);

  const change = async (mode) => {
    setBusy(true);
    try {
      const r = await saveAutopilot({ mode });
      setCfg(r.data);
      toast.success(mode === "auto" ? "Autopilot: terus jadual & post automatik" : "Autopilot: tunggu kelulusan anda");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <section className="panel fade-up p-6" data-testid="settings-autopilot-section">
      <div className="flex items-start gap-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/15 text-primary"><Bot className="h-4 w-4" /></div>
        <div>
          <h2 className="font-bold">AI Autopilot</h2>
          <p className="mt-1 text-sm text-muted-foreground">Pilih sama ada post yang ditulis AI setiap hari terus dijadualkan atau tunggu kelulusan anda dahulu.</p>
        </div>
      </div>
      <div className="mt-6 space-y-4">
        {cfg && <ModePicker value={cfg.mode} onChange={change} disabled={busy} />}
        {cfg && (
          <p className="text-xs text-muted-foreground" data-testid="settings-autopilot-status">
            Status: <b className={cfg.enabled ? "text-emerald-400" : "text-slate-300"}>{cfg.enabled ? "ON" : "OFF"}</b> · {cfg.topics.length} topik · had {cfg.daily_limit} group sehari
          </p>
        )}
        <Link to="/autopilot" className="inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline" data-testid="settings-autopilot-link">
          Urus topik & jadual Autopilot <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </section>
  );
}
